import { ActiveModelSerializer } from 'active-model-adapter';

export default class extends ActiveModelSerializer {
  isNewSerializerAPI = true;
}
